import { ContactTypeEnum } from "../../enum/contact-type.enum.model";
export interface TypeSelectContact {
  value: number;
  name: string;
  notAdd: boolean;
}
export class ContactList {
  email: ContactVM[];
  phoneNumber: ContactVM[];
  webSite: ContactVM[];
  social: ContactVM[];

  constructor(init?: ContactList) {
    Object.assign(this, init);
    if (!this.email) this.email = [];
    if (!this.phoneNumber) this.phoneNumber = [];
    if (!this.webSite) this.webSite = [];
    if (!this.social) this.social = [];
  }
}

export class ContactVM {
  id?: number;
  type: ContactTypeEnum;
  value?: string;
  externalId?: string;
  required?: boolean;

  constructor(init?: ContactVM) {
    Object.assign(this, init);
  }
}

export interface IContactRequest {
  type: number,
  externalId: string,
  value: string,
}
export interface IContactResponse {
  id: number,
  type: number,
  externalId: string,
  value: string,
}
